const opts = {
  filterable: false,
  sortable: false
};
export default {
  id: 'vehicle.dtcAlerts',
  name: 'vehicle.dtcAlerts',
  displayName: 'DTC Alerts',
  valueType: 'string',
  objectType: 'vehicle',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const dtcs = obj?.data?.obdTracker?.data?.dtcs || {};
    return Object.keys(dtcs);
  }
};